/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, runOn, markType, INotifyPropertyChanged_$type, PropertyChangedEventArgs, delegateRemove, enumGetBox, delegateCombine, Number_$type } from "igniteui-react-core";
import { DomWrapper_$type } from "igniteui-react-core";
import { List$1 } from "igniteui-react-core";
import { parseBool } from "igniteui-react-core";
import { dateGetMonth, dateNow, dateMinValue, dateAddYears, dateFromValues, dateMaxValue, dateGetDate, dateAddDays, dateAddMonths } from "igniteui-react-core";
import { SRProvider } from "igniteui-react-core";
import { ControlDisplayDensity_$type } from "igniteui-react-core";
import { BaseControlTheme_$type } from "igniteui-react-core";
import { DayOfWeek_$type } from "./DayOfWeek";
import { FirstWeek_$type } from "./FirstWeek";
import { BrushUtil } from "igniteui-react-core";
import { ObservableCollection$1 } from "igniteui-react-core";
import { DayInfo } from "./DayInfo";
import { Button } from "./Button";
import { ValueChangedEventArgs } from "./ValueChangedEventArgs";
import { CornerRadius } from "igniteui-react-core";
import { Icon } from "./Icon";
import { CalendarVisualModelExport } from "./CalendarVisualModelExport";
import { ButtonVisualModelExport } from "./ButtonVisualModelExport";
import { TextElementsVisualModelExport } from "./TextElementsVisualModelExport";
import { AppearanceHelper } from "igniteui-react-core";
import { NativeUI } from "igniteui-react-core";
import { FontUtil } from "igniteui-react-core";
import { truncate, intDivide, isNaN_ } from "igniteui-react-core";
import { stringIsNullOrWhiteSpace } from "igniteui-react-core";
import { timeSpanTotalDays } from "igniteui-react-core";
/**
 * @hidden
 */
var CalendarView = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CalendarView, _super);
    function CalendarView() {
        var _this = _super.call(this) || this;
        _this.j = null;
        _this.k = null;
        _this.n = null;
        _this.m = null;
        _this.o = null;
        _this.f = new List$1(DomWrapper_$type, 0);
        _this.e = new List$1(DomWrapper_$type, 0);
        _this.g = new List$1(DomWrapper_$type, 0);
        _this.h = new List$1(DomWrapper_$type, 0);
        _this.l = null;
        _this.q = null;
        _this.c = null;
        _this.i = null;
        _this.q = "day";
        _this.l = null;
        return _this;
    }
    CalendarView.prototype.ad = function () {
    };
    CalendarView.prototype.ac = function (a) {
        if (a == null) {
            this.i = null;
            return;
        }
        this.i = a;
        this.i.rootWrapper.setStyleProperty("background-color", "rgb(255, 255, 255)");
        var b = Math.round(a.rootWrapper.width());
        var c = Math.round(a.rootWrapper.height());
        this.u();
        this.am();
        this.an();
        this.al();
        var d = this.i.rootWrapper;
        d.listen("keydown", runOn(this, this.t));
        d.listen("focus", runOn(this, this.s));
    };
    CalendarView.prototype.r = function () {
        return this.q;
    };
    CalendarView.prototype.u = function () {
        if (this.i != null) {
            this.j = this.i.createElement("div");
            this.j.setStyleProperty("display", "flex");
            this.k = this.i.createElement("div");
            this.k.setStyleProperty("height", "100%");
            this.n = this.i.createElement("div");
            this.c.ce(this.i, this.n);
            this.aq();
            this.j.append(this.k);
            this.i.append(this.j);
            for (var a = 0; a < 42; a++) {
                var b = this.i.createElement("div");
                this.e.add(b);
            }
            this.c.cb(this.i, this.k, this.n, this.e);
            this.m = this.i.createElement("div");
            this.m.setStyleProperty("height", "100%");
            this.i.append(this.m);
            for (var c = 0; c < 12; c++) {
                var d = this.i.createElement("div");
                this.g.add(d);
            }
            this.c.cd(this.i, this.m, this.g);
            for (var e = 0; e < 12; e++) {
                var f = this.m.getChildAt(e);
                f.listen("click", runOn(this, this.x));
            }
            this.m.hide();
            this.o = this.i.createElement("div");
            this.o.setStyleProperty("height", "100%");
            this.i.append(this.o);
            for (var g = 0; g < 7; g++) {
                var h = this.i.createElement("div");
                this.h.add(h);
            }
            this.c.cf(this.i, this.o, this.h);
            for (var i = 0; i < 7; i++) {
                var j = this.o.getChildAt(i);
                j.listen("click", runOn(this, this.at));
            }
            this.o.listen("wheel", runOn(this, this.au));
            this.o.hide();
        }
    };
    CalendarView.prototype.am = function () {
        if (this.i != null) {
            var a = this.k.getChildAt(0);
            for (var b = 0; b < 4; b++) {
                var c = this.i.createElement("div");
                this.f.add(c);
            }
            this.c.cx(this.i, a, this.f);
            var d = a.getChildAt(0);
            var e = a.getChildAt(3);
            d.listen("click", runOn(this, this.ae));
            e.listen("click", runOn(this, this.z));
            var f = a.getChildAt(1);
            var g = a.getChildAt(2);
            f.listen("click", runOn(this, this.y));
            g.listen("click", runOn(this, this.av));
        }
    };
    CalendarView.prototype.an = function () {
        if (this.i != null) {
            var a = this.k.getChildAt(1).getChildAt(1).getChildAt(0);
            this.c.cz(a);
        }
    };
    CalendarView.prototype.al = function () {
        if (this.i != null) {
            this.c.cw(this.e);
            this.c.c0(this.n);
            var a = this.k.getChildAt(1);
            var b = a.getChildAt(1);
            for (var c = 1; c < 7; c++) {
                var d = b.getChildAt(c);
                for (var e = 0; e < 7; e++) {
                    var f = d.getChildAt(e);
                    f.listen("click", runOn(this, this.v));
                }
            }
        }
    };
    CalendarView.prototype.ap = function () {
        if (this.i != null) {
            this.c.c4(this.k);
        }
    };
    CalendarView.prototype.aq = function () {
        if (this.n != null) {
            if (this.c.aa == true) {
                this.n.show();
                this.n.setStyleProperty("display", "flex");
            }
            else {
                this.n.hide();
            }
        }
    };
    CalendarView.prototype.ak = function () {
        if (this.i != null) {
            this.c.cu(this.f._inner[1]);
            this.c.c3(this.f._inner[2]);
        }
    };
    CalendarView.prototype.ah = function (a, b) {
        if (a === void 0) {
            a = false;
        }
        if (b === void 0) {
            b = false;
        }
        if (this.i != null) {
            this.c.cw(this.e, a, b);
            this.c.c0(this.n);
            this.c.b8(this.f);
        }
    };
    CalendarView.prototype.aj = function () {
        if (this.g.count != 0) {
            this.c.cy(this.g);
        }
    };
    CalendarView.prototype.ao = function () {
        if (this.h.count != 0) {
            this.c.c2(this.h);
        }
    };
    CalendarView.prototype.ag = function (a) {
        if (a === void 0) {
            a = false;
        }
        this.ah();
        this.ak();
        this.q = "day";
        this.j.show();
        this.j.setStyleProperty("display", "flex");
        this.m.hide();
        this.o.hide();
        this.ai(a);
        this.w();
    };
    CalendarView.prototype.ai = function (a) {
        if (a === void 0) {
            a = false;
        }
        var b = null;
        var c = null;
        var d = null;
        for (var e = 0; e < this.e.count; e++) {
            var f = this.e._inner[e];
            var g = parseBool(f.getAttribute("data-disabled").toString());
            var h = f.getAttribute("data-month").toString();
            var i = parseBool(f.getAttribute("data-selected").toString());
            var j = parseBool(f.getAttribute("data-today").toString());
            if (i == true) {
                c = f;
            }
            if (j == true) {
                d = f;
            }
            var k = dateGetMonth(this.c.an).toString();
            if (g == false && k == h && b == null) {
                b = f;
            }
        }
        if (d != null) {
            b = d;
        }
        if (c != null && a == false) {
            b = c;
        }
        if (b == null) {
            for (var l = 0; l < this.f.count; l++) {
                var m = parseBool(this.f._inner[l].getAttribute("data-disabled").toString());
                if (m == false) {
                    b = this.f._inner[l];
                    break;
                }
            }
        }
        if (b != null) {
            this.d(b);
        }
    };
    CalendarView.prototype.d = function (a) {
        if (a == null) {
            return false;
        }
        var b = parseBool(a.getAttribute("data-disabled").toString());
        if (b) {
            return false;
        }
        this.l = a;
        return true;
    };
    CalendarView.prototype.w = function () {
        if (this.l != null) {
            this.l.parent().parent().focus(false);
        }
    };
    CalendarView.prototype.af = function (a, b) {
        if (a === void 0) {
            a = true;
        }
        if (b === void 0) {
            b = false;
        }
        var c = parseBool(this.f._inner[0].getAttribute("data-disabled").toString());
        if (c) {
            return;
        }
        this.c.b7(-1);
        this.ah(a, b);
        this.ak();
    };
    CalendarView.prototype.aa = function (a, b) {
        if (a === void 0) {
            a = true;
        }
        if (b === void 0) {
            b = false;
        }
        var c = parseBool(this.f._inner[3].getAttribute("data-disabled").toString());
        if (c) {
            return;
        }
        this.c.b7(1);
        this.ah(a, b);
        this.ak();
    };
    CalendarView.prototype.ar = function () {
        this.j.hide();
        this.m.show();
        this.m.setStyleProperty("display", "flex");
        this.o.hide();
        this.q = "month";
        this.aj();
        this.w();
    };
    CalendarView.prototype.as = function () {
        this.j.hide();
        this.m.hide();
        this.o.show();
        this.q = "year";
        this.ao();
        this.w();
    };
    CalendarView.prototype.s = function (a) {
    };
    CalendarView.prototype.t = function (a) {
        var b = a.which;
        if (this.q == "day") {
            var c = this.l.getAttribute("data-section").toString();
            var d = parseInt(this.l.getAttribute("data-index").toString());
            if (c == "header") {
                if (b == 37) {
                    if (d > 0) {
                        var e = this.f._inner[d - 1];
                        var f = this.d(e);
                        if (f == false && d > 1) {
                            e = this.f._inner[d - 2];
                            this.d(e);
                        }
                        this.w();
                    }
                    else {
                        this.af(false);
                        var g = parseBool(this.l.getAttribute("data-disabled").toString());
                        if (g == true) {
                            this.ai();
                            this.w();
                        }
                    }
                }
                else if (b == 39) {
                    if (d < 3) {
                        var h = this.f._inner[d + 1];
                        var i = this.d(h);
                        if (i == false && d < 2) {
                            h = this.f._inner[d + 2];
                            this.d(h);
                        }
                        this.w();
                    }
                    else {
                        this.aa(false);
                        var j = parseBool(this.l.getAttribute("data-disabled").toString());
                        if (j == true) {
                            this.ai();
                            this.w();
                        }
                    }
                }
                else if (b == 9) {
                    if (a.shiftKey) {
                        this.c.cl();
                    }
                    else {
                        a.preventDefault();
                        this.ah(true);
                        this.w();
                    }
                }
                else if (b == 13) {
                    a.preventDefault();
                    if (d == 0) {
                        this.af(false);
                    }
                    else if (d == 1) {
                        this.ar();
                    }
                    else if (d == 2) {
                        this.as();
                    }
                    else if (d == 3) {
                        this.aa(false);
                    }
                }
            }
            else if (c == "days") {
                var k = this.l.getAttribute("data-day").toString();
                var l = this.l.getAttribute("data-month").toString();
                if (b == 37) {
                    if (d == 0) {
                        this.af(true, true);
                        this.w();
                    }
                    else {
                        var m = this.e._inner[d - 1];
                        var n = m.getAttribute("data-day").toString();
                        var o = m.getAttribute("data-month").toString();
                        if (l == o) {
                            this.d(m);
                            this.w();
                        }
                        else {
                            this.af();
                            var p = this.p(n, o);
                            this.d(p);
                            this.w();
                        }
                    }
                }
                else if (b == 39) {
                    if (d == 41) {
                        this.aa(true, false);
                        this.w();
                    }
                    else {
                        var q = this.e._inner[d + 1];
                        var r = q.getAttribute("data-day").toString();
                        var s = q.getAttribute("data-month").toString();
                        if (l == s) {
                            this.d(q);
                            this.w();
                        }
                        else {
                            this.aa();
                            var t = this.p(r, s);
                            this.d(t);
                            this.w();
                        }
                    }
                }
                else if (b == 40) {
                    if (d >= 35) {
                        this.aa();
                        var u = this.p(k, l);
                        var v = parseInt(u.getAttribute("data-index").toString());
                        var w = this.e._inner[v + 7];
                        var x = w.getAttribute("data-day").toString();
                        var y = w.getAttribute("data-month").toString();
                        var z = this.p(x, y);
                        this.d(z);
                        this.w();
                    }
                    else {
                        var aa = this.e._inner[d + 7];
                        var ab = aa.getAttribute("data-day").toString();
                        var ac = aa.getAttribute("data-month").toString();
                        if (l == ac) {
                            this.d(aa);
                            this.w();
                        }
                        else {
                            this.aa();
                            var ad = this.p(ab, ac);
                            this.d(ad);
                            this.w();
                        }
                    }
                }
                else if (b == 38) {
                    if (d <= 6) {
                        this.af();
                        var ae = this.p(k, l);
                        var af = parseInt(ae.getAttribute("data-index").toString());
                        var ag = this.e._inner[af - 7];
                        var ah = ag.getAttribute("data-day").toString();
                        var ai = ag.getAttribute("data-month").toString();
                        var aj = this.p(ah, ai);
                        this.d(aj);
                        this.w();
                    }
                    else {
                        var ak = this.e._inner[d - 7];
                        var al = ak.getAttribute("data-day").toString();
                        var am = ak.getAttribute("data-month").toString();
                        if (l == am) {
                            this.d(ak);
                            this.w();
                        }
                        else {
                            this.af();
                            var an = this.p(al, am);
                            this.d(an);
                            this.w();
                        }
                    }
                }
                else if (b == 34) {
                    this.aa();
                    this.w();
                }
                else if (b == 33) {
                    this.af();
                    this.w();
                }
                else if (b == 9) {
                    if (a.shiftKey) {
                        a.preventDefault();
                        var ao = this.f._inner[1];
                        this.d(ao);
                        this.w();
                    }
                    else {
                        this.c.cl();
                    }
                }
            }
        }
        else if (this.q == "month") {
            var ap = parseInt(this.l.getAttribute("data-index").toString());
            if (b == 37) {
                if (ap == 0) {
                    var aq = this.g._inner[11];
                    this.d(aq);
                    this.w();
                }
                else {
                    var ar = this.g._inner[ap - 1];
                    this.d(ar);
                    this.w();
                }
            }
            else if (b == 39) {
                if (ap == 11) {
                    var as = this.g._inner[0];
                    this.d(as);
                    this.w();
                }
                else {
                    var at = this.g._inner[ap + 1];
                    this.d(at);
                    this.w();
                }
            }
            else if (b == 40) {
                if (ap >= 9) {
                    var au = this.g._inner[ap - 9];
                    this.d(au);
                    this.w();
                }
                else {
                    var av = this.g._inner[ap + 3];
                    this.d(av);
                    this.w();
                }
            }
            else if (b == 38) {
                if (ap <= 2) {
                    var aw = this.g._inner[ap + 9];
                    this.d(aw);
                    this.w();
                }
                else {
                    var ax = this.g._inner[ap - 3];
                    this.d(ax);
                    this.w();
                }
            }
            else if (b == 13) {
                this.d(this.f._inner[1]);
                this.w();
            }
        }
        else if (this.q == "year") {
            var ay = parseInt(this.l.getAttribute("data-index").toString());
            if (b == 40) {
                this.c.cs(this.h, 1);
                this.w();
            }
            else if (b == 38) {
                this.c.cs(this.h, -1);
                this.w();
            }
            else if (b == 13) {
                this.d(this.f._inner[2]);
                this.w();
            }
        }
        if (b == 27) {
            this.ag();
            this.c.cl();
        }
        if (a.altKey == true) {
            if (b == 38) {
                this.ag();
                this.c.cl();
            }
        }
    };
    CalendarView.prototype.p = function (a, b) {
        var c = null;
        var d = null;
        for (var e = 0; e < 42; e++) {
            var f = this.e._inner[e];
            var g = f.getAttribute("data-day").toString();
            var h = f.getAttribute("data-month").toString();
            if (b == h && d == null) {
                d = f;
            }
            if (b == h && a == g) {
                c = f;
                break;
            }
        }
        if (c == null) {
            c = d;
        }
        return c;
    };
    CalendarView.prototype.ae = function (a) {
        var b = this.f._inner[0];
        var c = parseBool(b.getAttribute("data-disabled").toString());
        if (c == true) {
            return;
        }
        this.af();
    };
    CalendarView.prototype.z = function (a) {
        var b = this.f._inner[3];
        var c = parseBool(b.getAttribute("data-disabled").toString());
        if (c == true) {
            return;
        }
        this.aa();
    };
    CalendarView.prototype.y = function (a) {
        var b = this.f._inner[1];
        var c = parseBool(b.getAttribute("data-disabled").toString());
        if (c == true) {
            return;
        }
        this.ar();
    };
    CalendarView.prototype.av = function (a) {
        var b = this.f._inner[2];
        var c = parseBool(b.getAttribute("data-disabled").toString());
        if (c == true) {
            return;
        }
        this.as();
    };
    CalendarView.prototype.v = function (e_) {
        var a = (e_.originalEvent.currentTarget);
        var b = a.innerText;
        if (b != "") {
            var c = a.lastChild.lastChild.lastChild;
            var d = parseBool(c.getAttribute("data-disabled").toString());
            if (d == false) {
                var e = c.getAttribute("data-month").toString();
                var f = c.getAttribute("data-year").toString();
                this.c.ch(b, e, f);
            }
        }
    };
    CalendarView.prototype.x = function (e_) {
        var a = (e_.originalEvent.currentTarget);
        var b = a.getAttribute("data-month").toString();
        if (b != "") {
            var c = parseInt(b);
            var d = a.lastChild.lastChild.lastChild;
            var e = parseBool(d.getAttribute("data-disabled").toString());
            if (e == false) {
                this.c.b9(c);
                this.ag();
            }
        }
    };
    CalendarView.prototype.at = function (e_) {
        var a = (e_.originalEvent.currentTarget);
        var b = a.innerText;
        if (b != "") {
            var c = parseInt(b);
            var d = a.lastChild.lastChild.lastChild;
            var e = parseBool(d.getAttribute("data-disabled").toString());
            if (e == false) {
                this.c.ca(c);
                this.ag();
            }
        }
    };
    CalendarView.prototype.au = function (e_) {
        e_.preventDefault();
        var a = (e_.originalEvent.deltaY);
        this.c.cs(this.h, a);
    };
    CalendarView.prototype.a = function () {
        var rect_ = this.i.rootWrapper.getNativeElement().getBoundingClientRect();
        var a = (rect_.top);
        var b = (rect_.left);
        var c = new Array(2);
        c[0] = a;
        c[1] = b;
        return c;
    };
    CalendarView.prototype.b = function (a) {
        var rect_ = a.getNativeElement().getBoundingClientRect();
        var b = (rect_.top);
        var c = (rect_.left);
        var d = new Array(2);
        d[0] = b;
        d[1] = c;
        return d;
    };
    CalendarView.prototype.ab = function () {
    };
    CalendarView.$t = markType(CalendarView, 'CalendarView');
    return CalendarView;
}(Base));
export { CalendarView };
/**
 * @hidden
 */
var Calendar = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(Calendar, _super);
    function Calendar() {
        var _this = _super.call(this) || this;
        _this.k = null;
        _this.an = dateNow();
        _this.aj = new Date();
        _this.ae = null;
        _this.af = null;
        _this.ac = null;
        _this.ag = null;
        _this.ai = null;
        _this.ah = null;
        _this.ad = null;
        _this.h = null;
        _this.am = dateMinValue();
        _this.propertyChanged = null;
        _this.close = null;
        _this.valueChanged = null;
        _this.u = null;
        _this.ap = dateMinValue();
        _this.ao = dateNow();
        _this.al = dateMinValue();
        _this.ak = dateMaxValue();
        _this.e = 3;
        _this.c = 1;
        _this.c8 = BrushUtil.g(0, 255, 255, 255);
        _this.de = BrushUtil.g(255, 33, 150, 243);
        _this.dg = BrushUtil.g(255, 21, 112, 184);
        _this.db = BrushUtil.g(76, 33, 150, 243);
        _this.dd = BrushUtil.g(50, 186, 191, 199);
        _this.dh = BrushUtil.g(255, 24, 29, 31);
        _this.df = BrushUtil.g(255, 255, 255, 255);
        _this.dc = BrushUtil.g(255, 24, 29, 31);
        _this.da = BrushUtil.g(255, 33, 150, 243);
        _this.c9 = BrushUtil.g(255, 33, 150, 243);
        _this.w = false;
        _this.s = null;
        _this.m = 0;
        _this.p = 0;
        _this.x = false;
        _this.aj = dateAddYears(_this.aj, -200);
        _this.ae = new ObservableCollection$1(DayInfo.$, 0);
        _this.af = new ObservableCollection$1(Button.$, 0);
        _this.ac = new ObservableCollection$1(Button.$, 0);
        _this.ag = new ObservableCollection$1(Button.$, 0);
        _this.ai = new ObservableCollection$1(Button.$, 0);
        _this.ah = new ObservableCollection$1(DomWrapper_$type, 0);
        _this.ad = new ObservableCollection$1(DomWrapper_$type, 0);
        var a = new CalendarView();
        a.c = _this;
        _this.k = a;
        _this.k.ad();
        return _this;
    }
    Calendar.prototype.cl = function () {
        if (this.close != null) {
            this.close(this);
        }
    };
    Calendar.prototype.cn = function (a) {
        var b = this.ap;
        this.ap = a;
        if (this.valueChanged != null) {
            this.valueChanged(this, ((function () {
                var $ret = new ValueChangedEventArgs();
                $ret.oldValue = b;
                $ret.newValue = a;
                return $ret;
            })()));
        }
        if (+(this.at) != +(dateMinValue())) {
            this.an = this.at;
        }
        this.cq();
    };
    Calendar.prototype.ch = function (a, b, c) {
        var d = dateFromValues(parseInt(c), parseInt(b), parseInt(a), 0, 0, 0, 0);
        this.cn(d);
    };
    Calendar.prototype.notifySizeChanged = function () {
        this.k.ab();
    };
    Calendar.prototype.destroy = function () {
        if (this.h != null) {
            var a = this.h;
            a.clicked = delegateRemove(a.clicked, runOn(this, this.c5));
        }
        this.provideContainer(null);
    };
    Calendar.prototype.provideContainer = function (a) {
        this.k.ac(a);
    };
    Object.defineProperty(Calendar.prototype, "v", {
        get: function () {
            if (this.u == null) {
                this.u = new SRProvider(this.k.i);
                this.u.cb("Calendar");
            }
            return this.u;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "at", {
        get: function () {
            return this.ap;
        },
        set: function (a) {
            var b = this.ap;
            this.am = b;
            this.ap = a;
            if (+b != +(this.ap)) {
                this.cm("Value", b, this.ap);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "as", {
        get: function () {
            return this.ao;
        },
        set: function (a) {
            var b = this.ao;
            this.ao = a;
            if (+b != +(this.ao)) {
                this.cm("Today", b, this.ao);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "ar", {
        get: function () {
            return this.al;
        },
        set: function (a) {
            var b = this.al;
            this.al = a;
            if (+b != +(this.al)) {
                this.cm("MinDate", b, this.al);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "aq", {
        get: function () {
            return this.ak;
        },
        set: function (a) {
            var b = this.ak;
            this.ak = a;
            if (+b != +(this.ak)) {
                this.cm("MaxDate", b, this.ak);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "f", {
        get: function () {
            return this.e;
        },
        set: function (a) {
            var b = this.e;
            this.e = a;
            if (b != this.e) {
                this.cm("Density", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, this.e));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "d", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            var b = this.c;
            this.c = a;
            if (b != this.c) {
                this.cm("BaseTheme", enumGetBox(BaseControlTheme_$type, b), enumGetBox(BaseControlTheme_$type, this.c));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "di", {
        get: function () {
            return this.c8;
        },
        set: function (a) {
            var b = this.c8;
            this.c8 = a;
            if (b != this.c8) {
                this.cm("BackgroundColor", b, this.c8);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "dp", {
        get: function () {
            return this.de;
        },
        set: function (a) {
            var b = this.de;
            this.de = a;
            if (b != this.de) {
                this.cm("SelectedDateBackgroundColor", b, this.de);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "dr", {
        get: function () {
            return this.dg;
        },
        set: function (a) {
            var b = this.dg;
            this.dg = a;
            if (b != this.dg) {
                this.cm("SelectedFocusDateBackgroundColor", b, this.dg);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "dl", {
        get: function () {
            return this.db;
        },
        set: function (a) {
            var b = this.db;
            this.db = a;
            if (b != this.db) {
                this.cm("FocusDateBackgroundColor", b, this.db);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "dn", {
        get: function () {
            return this.dd;
        },
        set: function (a) {
            var b = this.dd;
            this.dd = a;
            if (b != this.dd) {
                this.cm("HoverBackgroundColor", b, this.dd);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "ds", {
        get: function () {
            return this.dh;
        },
        set: function (a) {
            var b = this.dh;
            this.dh = a;
            if (b != this.dh) {
                this.cm("TextColor", b, this.dh);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "dq", {
        get: function () {
            return this.df;
        },
        set: function (a) {
            var b = this.df;
            this.df = a;
            if (b != this.df) {
                this.cm("SelectedDateTextColor", b, this.df);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "dm", {
        get: function () {
            return this.dc;
        },
        set: function (a) {
            var b = this.dc;
            this.dc = a;
            if (b != this.dc) {
                this.cm("FocusDateTextColor", b, this.dc);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "dk", {
        get: function () {
            return this.da;
        },
        set: function (a) {
            var b = this.da;
            this.da = a;
            if (b != this.da) {
                this.cm("CurrentDateTextColor", b, this.da);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "dj", {
        get: function () {
            return this.c9;
        },
        set: function (a) {
            var b = this.c9;
            this.c9 = a;
            if (b != this.c9) {
                this.cm("CurrentDateBorderColor", b, this.c9);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "z", {
        get: function () {
            return this.w;
        },
        set: function (a) {
            var b = this.w;
            this.w = a;
            if (b != this.w) {
                this.cm("ShowTodayButton", b, this.w);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "t", {
        get: function () {
            return this.s;
        },
        set: function (a) {
            var b = this.s;
            this.s = a;
            if (b != this.s) {
                this.cm("TextStyle", b, this.s);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "n", {
        get: function () {
            return this.m;
        },
        set: function (a) {
            var b = this.m;
            this.m = a;
            if (b != this.m) {
                this.cm("FirstDayOfWeek", enumGetBox(DayOfWeek_$type, b), enumGetBox(DayOfWeek_$type, this.m));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "q", {
        get: function () {
            return this.p;
        },
        set: function (a) {
            var b = this.p;
            this.p = a;
            if (b != this.p) {
                this.cm("FirstWeekOfYear", enumGetBox(FirstWeek_$type, b), enumGetBox(FirstWeek_$type, this.p));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "aa", {
        get: function () {
            return this.x;
        },
        set: function (a) {
            var b = this.x;
            this.x = a;
            if (b != this.x) {
                this.cm("ShowWeekNumbers", b, this.x);
            }
        },
        enumerable: true,
        configurable: true
    });
    Calendar.prototype.cm = function (a, b, c) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        this.co(a, b, c);
    };
    Calendar.prototype.co = function (a, b, c) {
        switch (a) {
            case "Density":
                this.ct();
                break;
            case "BaseTheme":
                this.cv();
                break;
            case "Value":
                if (+(this.at) != +(dateMinValue())) {
                    if (dateGetDate(this.at) < dateGetDate(this.ar) || dateGetDate(this.at) > dateGetDate(this.aq)) {
                        this.at = this.am;
                    }
                }
                this.am = this.at;
                if (+(this.at) != +(dateMinValue())) {
                    this.an = this.at;
                }
                this.cq();
                break;
            case "Today":
                var d = Base.compareSimple(this.as, this.ar);
                var e = Base.compareSimple(this.as, this.aq);
                if (d < 0) {
                    this.ao = this.ar;
                }
                else if (e > 0) {
                    this.ao = this.aq;
                }
                if (+(this.at) == +(dateMinValue())) {
                    this.an = this.as;
                }
                this.cq();
                break;
            case "MaxDate":
            case "MinDate":
                var f = Base.compareSimple(this.ar, this.aq);
                if (f >= 0) {
                    this.aq = dateMaxValue();
                }
                var g = Base.compareSimple(this.an, this.ar);
                var h = Base.compareSimple(this.an, this.aq);
                if (g < 0) {
                    this.an = this.ar;
                }
                else if (h > 0) {
                    this.an = this.aq;
                }
                this.cq();
                break;
            case "TextColor":
            case "SelectedDateTextColor":
            case "FocusDateTextColor":
            case "CurrentDateTextColor":
            case "CurrentDateBorderColor":
            case "BackgroundColor":
            case "FocusDateBackgroundColor":
            case "SelectedFocusDateBackgroundColor":
            case "SelectedDateBackgroundColor":
            case "HoverBackgroundColor":
                this.c6();
                break;
            case "TextStyle":
                this.c7();
                break;
            case "ShowTodayButton":
                this.k.ap();
                break;
            case "FirstDayOfWeek":
                this.cq();
                break;
            case "FirstWeekOfYear":
            case "ShowWeekNumbers":
                this.k.aq();
                this.cq();
                break;
        }
    };
    Calendar.prototype.c6 = function () {
        for (var a = 0; a < this.af.count; a++) {
            if (this.ds != null) {
                this.af._inner[a].s5 = this.ds;
            }
            if (this.dm != null) {
                this.af._inner[a].s1 = this.dm;
            }
            if (this.di != null) {
                this.af._inner[a].sv = this.di;
            }
            if (this.dl != null) {
                this.af._inner[a].s0 = this.dl;
            }
            if (this.dn != null) {
                this.af._inner[a].s2 = this.dn;
            }
        }
        for (var b = 0; b < this.ac.count; b++) {
            if (this.ds != null) {
                this.ac._inner[b].s5 = this.ds;
            }
            if (this.dm != null) {
                this.ac._inner[b].s1 = this.dm;
            }
            if (this.di != null) {
                this.ac._inner[b].sv = this.di;
            }
            if (this.dl != null) {
                this.ac._inner[b].s0 = this.dl;
            }
            if (this.dn != null) {
                this.ac._inner[b].s2 = this.dn;
            }
        }
        for (var c = 0; c < this.ag.count; c++) {
            if (this.ds != null) {
                this.ag._inner[c].s5 = this.ds;
            }
            if (this.dm != null) {
                this.ag._inner[c].s1 = this.dm;
            }
            if (this.di != null) {
                this.ag._inner[c].sv = this.di;
            }
            if (this.dl != null) {
                this.ag._inner[c].s0 = this.dl;
            }
            if (this.dn != null) {
                this.ag._inner[c].s2 = this.dn;
            }
        }
        for (var d = 0; d < this.ai.count; d++) {
            if (this.ds != null) {
                this.ai._inner[d].s5 = this.ds;
            }
            if (this.dm != null) {
                this.ai._inner[d].s1 = this.dm;
            }
            if (this.di != null) {
                this.ai._inner[d].sv = this.di;
            }
            if (this.dl != null) {
                this.ai._inner[d].s0 = this.dl;
            }
            if (this.dn != null) {
                this.ai._inner[d].s2 = this.dn;
            }
        }
    };
    Calendar.prototype.c7 = function () {
        for (var a = 0; a < this.af.count; a++) {
            if (this.s != null) {
                this.af._inner[a].v = this.s;
            }
        }
        for (var b = 0; b < this.ac.count; b++) {
            if (this.s != null) {
                this.ac._inner[b].v = this.s;
            }
        }
        for (var c = 0; c < this.ag.count; c++) {
            if (this.s != null) {
                this.ag._inner[c].v = this.s;
            }
        }
        for (var d = 0; d < this.ai.count; d++) {
            if (this.s != null) {
                this.ai._inner[d].v = this.s;
            }
        }
    };
    Calendar.prototype.cj = function () {
        this.k.ai();
        this.k.w();
    };
    Calendar.prototype.cv = function () {
    };
    Calendar.prototype.ct = function () {
    };
    Calendar.prototype.cg = function () {
        this.at = dateMinValue();
        this.k.ah();
    };
    Calendar.prototype.cq = function () {
        this.k.an();
        this.cc();
        this.k.ak();
        this.k.ao();
        this.k.ah();
    };
    Calendar.prototype.cb = function (a, b, c, d) {
        b.setStyleProperty("display", "flex");
        b.setStyleProperty("flex-direction", "column");
        b.setStyleProperty("justify-content", "space-evenly");
        var e = a.createElement("div");
        e.setStyleProperty("display", "flex");
        e.setStyleProperty("justify-content", "space-evenly");
        e.setStyleProperty("width", "100%");
        e.setAttribute("role", "row");
        var f = a.createElement("div");
        f.setStyleProperty("width", "15%");
        var g = a.createElement("div");
        g.setStyleProperty("width", "20%");
        var h = a.createElement("div");
        h.setStyleProperty("width", "20%");
        var i = a.createElement("div");
        i.setStyleProperty("width", "15%");
        e.append(f);
        e.append(g);
        e.append(h);
        e.append(i);
        b.append(e);
        var j = a.createElement("div");
        j.setStyleProperty("display", "flex");
        j.setStyleProperty("flex-direction", "row");
        j.setStyleProperty("justify-content", "space-evenly");
        c.setStyleProperty("padding-bottom", "6px");
        j.append(c);
        var k = a.createElement("div");
        k.setStyleProperty("display", "flex");
        k.setStyleProperty("flex-direction", "column");
        k.setStyleProperty("width", "220px");
        k.setAttribute("role", "grid");
        k.setAttribute("aria-readonly", "true");
        j.append(k);
        b.append(j);
        var l = 0;
        for (var m = 0; m < 7; m++) {
            var n = a.createElement("div");
            n.setAttribute("role", "row");
            n.setStyleProperty("display", "flex");
            n.setStyleProperty("justify-content", "space-evenly");
            if (m == 0) {
                for (var o = 0; o < 7; o++) {
                    var p = a.createElement("div");
                    p.setAttribute("role", "columnheader");
                    p.setAttribute("scope", "col");
                    p.setStyleProperty("text-align", "center");
                    p.setStyleProperty("vertical-align", "middle");
                    p.setStyleProperty("width", "12%");
                    var q = a.createElement("span");
                    q.setStyleProperty("font", "16px \"Segoe UI\", Verdana");
                    q.setStyleProperty("color", "rgb(24, 29, 31)");
                    p.append(q);
                    this.ad.add(q);
                    n.append(p);
                }
                k.append(n);
            }
            else {
                for (var r = 0; r < 7; r++) {
                    var s = a.createElement("div");
                    s.setAttribute("role", "gridcell");
                    s.setStyleProperty("justify-content", "center");
                    var t = d._inner[l];
                    var u = this.j(a, s, t);
                    u.bh = 30;
                    u.bg = 30;
                    this.ac.add(u);
                    u.ih = "btnDays" + r.toString();
                    s.setStyleProperty("width", "12%");
                    s.setStyleProperty("height", "100%");
                    n.append(s);
                    l++;
                }
                k.append(n);
            }
        }
        var v = a.createElement("div");
        v.setStyleProperty("display", "flex");
        v.setStyleProperty("padding-bottom", "4px");
        var w = a.createElement("div");
        w.setStyleProperty("width", "100%");
        w.setStyleProperty("justify-content", "center");
        var x = a.createElement("div");
        this.h = this.j(a, w, x);
        var y = this.h;
        y.clicked = delegateCombine(y.clicked, runOn(this, this.c5));
        var z = x.getChildAt(0);
        var aa = !stringIsNullOrWhiteSpace(this.v.b1("Today")) ? this.v.b1("Today") : "Today";
        z.setText(aa);
        x.parent().parent().setAttribute("aria-label", aa);
        v.append(w);
        b.append(v);
        this.c4(b);
        this.cc();
    };
    Calendar.prototype.ce = function (a, b) {
        b.setStyleProperty("display", "flex");
        b.setStyleProperty("flex-direction", "column");
        b.setStyleProperty("padding-top", "26px");
        var c = this.ab();
        for (var d = 0; d < 6; d++) {
            var e = a.createElement("div");
            e.setAttribute("aria-hidden", "true");
            e.setStyleProperty("text-align", "center");
            e.setStyleProperty("vertical-align", "middle");
            e.setStyleProperty("height", "30px");
            e.setStyleProperty("width", "25px");
            e.setStyleProperty("border-width", "0px 1px 0px 0px");
            e.setStyleProperty("border-style", "solid");
            e.setStyleProperty("border-color", "rgb(163, 172, 184)");
            var f = a.createElement("span");
            f.setAttribute("aria-hidden", "true");
            f.setStyleProperty("font", "14px \"Segoe UI\", Verdana");
            f.setStyleProperty("color", "rgb(24, 29, 31)");
            e.append(f);
            this.ah.add(f);
            f.setText(c._inner[d].toString());
            b.append(e);
        }
    };
    Calendar.prototype.c5 = function (a, b) {
        this.an = this.as;
        this.cc();
        this.k.ag(true);
    };
    Calendar.prototype.c4 = function (a) {
        if (this.z == true) {
            var b = a.getChildAt(2);
            b.setStyleProperty("display", "flex");
        }
        else {
            var c = a.getChildAt(2);
            c.setStyleProperty("display", "none");
        }
    };
    Calendar.prototype.cd = function (a, b, c) {
        b.setStyleProperty("display", "flex");
        b.setStyleProperty("flex-direction", "row");
        b.setStyleProperty("flex-wrap", "wrap");
        b.setStyleProperty("margin", "2px");
        b.setStyleProperty("justify-content", "center");
        b.setStyleProperty("width", "100%");
        b.setStyleProperty("height", "100%");
        b.setAttribute("role", "grid");
        b.setAttribute("aria-readonly", "true");
        for (var d = 0; d < 12; d++) {
            var e = a.createElement("div");
            e.setStyleProperty("margin", "5px");
            e.setAttribute("data-month", (d + 1).toString());
            var f = c._inner[d];
            var g = this.j(a, e, f);
            g.bh = 40;
            this.ag.add(g);
            e.setStyleProperty("width", "28%");
            var h = e.getChildAt(0);
            h.setStyleProperty("width", "100%");
            var i = f.getChildAt(0);
            var j = "";
            var k = d + 1;
            switch (k) {
                case 1:
                    f.parent().parent().setAttribute("aria-label", !stringIsNullOrWhiteSpace(this.v.b1("January_Full")) ? this.v.b1("January_Full") : "January");
                    j = !stringIsNullOrWhiteSpace(this.v.b1("January_Short")) ? this.v.b1("January_Short") : "Jan";
                    break;
                case 2:
                    f.parent().parent().setAttribute("aria-label", !stringIsNullOrWhiteSpace(this.v.b1("February_Full")) ? this.v.b1("February_Full") : "February");
                    j = !stringIsNullOrWhiteSpace(this.v.b1("February_Short")) ? this.v.b1("February_Short") : "Feb";
                    break;
                case 3:
                    f.parent().parent().setAttribute("aria-label", !stringIsNullOrWhiteSpace(this.v.b1("March_Full")) ? this.v.b1("March_Full") : "March");
                    j = !stringIsNullOrWhiteSpace(this.v.b1("March_Short")) ? this.v.b1("March_Short") : "Mar";
                    break;
                case 4:
                    f.parent().parent().setAttribute("aria-label", !stringIsNullOrWhiteSpace(this.v.b1("April_Full")) ? this.v.b1("April_Full") : "April");
                    j = !stringIsNullOrWhiteSpace(this.v.b1("April_Short")) ? this.v.b1("April_Short") : "Apr";
                    break;
                case 5:
                    f.parent().parent().setAttribute("aria-label", !stringIsNullOrWhiteSpace(this.v.b1("May_Full")) ? this.v.b1("May_Full") : "May");
                    j = !stringIsNullOrWhiteSpace(this.v.b1("May_Short")) ? this.v.b1("May_Short") : "May";
                    break;
                case 6:
                    f.parent().parent().setAttribute("aria-label", !stringIsNullOrWhiteSpace(this.v.b1("June_Full")) ? this.v.b1("June_Full") : "June");
                    j = !stringIsNullOrWhiteSpace(this.v.b1("June_Short")) ? this.v.b1("June_Short") : "Jun";
                    break;
                case 7:
                    f.parent().parent().setAttribute("aria-label", !stringIsNullOrWhiteSpace(this.v.b1("July_Full")) ? this.v.b1("July_Full") : "July");
                    j = !stringIsNullOrWhiteSpace(this.v.b1("July_Short")) ? this.v.b1("July_Short") : "Jul";
                    break;
                case 8:
                    f.parent().parent().setAttribute("aria-label", !stringIsNullOrWhiteSpace(this.v.b1("August_Full")) ? this.v.b1("August_Full") : "August");
                    j = !stringIsNullOrWhiteSpace(this.v.b1("August_Short")) ? this.v.b1("August_Short") : "Aug";
                    break;
                case 9:
                    f.parent().parent().setAttribute("aria-label", !stringIsNullOrWhiteSpace(this.v.b1("September_Full")) ? this.v.b1("September_Full") : "September");
                    j = !stringIsNullOrWhiteSpace(this.v.b1("September_Short")) ? this.v.b1("September_Short") : "Sep";
                    break;
                case 10:
                    f.parent().parent().setAttribute("aria-label", !stringIsNullOrWhiteSpace(this.v.b1("October_Full")) ? this.v.b1("October_Full") : "October");
                    j = !stringIsNullOrWhiteSpace(this.v.b1("October_Short")) ? this.v.b1("October_Short") : "Oct";
                    break;
                case 11:
                    f.parent().parent().setAttribute("aria-label", !stringIsNullOrWhiteSpace(this.v.b1("November_Full")) ? this.v.b1("November_Full") : "November");
                    j = !stringIsNullOrWhiteSpace(this.v.b1("November_Short")) ? this.v.b1("November_Short") : "Nov";
                    break;
                case 12:
                    f.parent().parent().setAttribute("aria-label", !stringIsNullOrWhiteSpace(this.v.b1("December_Full")) ? this.v.b1("December_Full") : "December");
                    j = !stringIsNullOrWhiteSpace(this.v.b1("December_Short")) ? this.v.b1("December_Short") : "Dec";
                    break;
            }
            g.ih = "btnMonth" + j;
            i.setText(j);
            f.setAttribute("data-index", d.toString());
            f.append(i);
            b.append(e);
        }
    };
    Calendar.prototype.cf = function (a, b, c) {
        b.setStyleProperty("width", "100%");
        b.setStyleProperty("height", "100%");
        var d = this.an.getFullYear() - 3;
        b.setStyleProperty("padding", "5px");
        b.setAttribute("role", "grid");
        b.setAttribute("aria-readonly", "true");
        for (var e = 0; e < 7; e++) {
            var f = a.createElement("div");
            var g = c._inner[e];
            var h = this.j(a, f, g);
            this.ai.add(h);
            f.setStyleProperty("width", "100%");
            f.setStyleProperty("height", "14%");
            f.setStyleProperty("justify-content", "center");
            var i = f.getChildAt(0);
            i.setStyleProperty("width", "98%");
            var j = g.getChildAt(0);
            h.ih = "btnYear" + e.toString();
            j.setText(d.toString());
            d++;
            g.setAttribute("data-index", e.toString());
            g.append(j);
            b.append(f);
        }
    };
    Calendar.prototype.cc = function () {
        if (+(this.an) == +(dateMinValue())) {
            this.an = dateNow();
        }
        this.ae.clear();
        var a = dateAddDays(this.an, -(this.an.getDate() - 1));
        var b = this.n;
        var c = a.getDay();
        while (c != b) {
            a = dateAddDays(a, -1);
            c = a.getDay();
        }
        while (this.ae.count < 42) {
            var d = new DayInfo();
            d.b = a.getDate();
            d.c = dateGetMonth(a);
            d.d = a.getFullYear();
            d.a = a.getDay();
            this.ae.add(d);
            a = dateAddDays(a, 1);
        }
    };
    Calendar.prototype.ab = function () {
        var a = new List$1(Number_$type, 0);
        if (this.aa == false) {
            for (var b = 0; b < 6; b++) {
                a.add(b);
            }
            return a;
        }
        var c = dateFromValues(this.an.getFullYear(), dateGetMonth(this.an), 1, 0, 0, 0, 0);
        for (var d = 0; d < 6; d++) {
            var e = 0;
            if (this.q == 2) {
                e = this.a7(c, this.q, this.n);
            }
            else {
                e = this.a7(c, this.q, this.n);
            }
            if (this.q == 0 || this.q == 2) {
                if (e == 2 && a._inner[d - 1] == 53) {
                    var f = c;
                    for (var g = 0; g < 6; g++) {
                        if (f.getDay() == this.n) {
                            if (f.getDate() > 1) {
                                a._inner[d - 1] = 1;
                            }
                            else {
                                e = 1;
                            }
                        }
                        else if (f.getDay() < this.n) {
                            f = dateAddDays(f, 1);
                        }
                        else if (f.getDay() > this.n) {
                            f = dateAddDays(f, -1);
                        }
                    }
                }
            }
            a.add(e);
            c = dateAddDays(c, 7);
        }
        return a;
    };
    Calendar.prototype.a6 = function (a) {
        var b = dateAddMonths(dateAddDays(a, -a.getDate() + 1), -dateGetMonth(a) + 1);
        var c = dateAddDays(dateAddYears(b, 1), -1);
        var d = [6, 7, 8, 9, 10, 4, 5];
        var e = truncate(timeSpanTotalDays((+a - +b)));
        var f = e + d[b.getDay()];
        var g = intDivide(f, 7);
        switch (g) {
            case 0: return this.a6(dateAddDays(b, -1));
            case 53: if (c.getDay() < 4) {
                return 1;
            }
            else {
                return g;
            }
            default: return g;
        }
    };
    Calendar.prototype.a7 = function (a, b, c) {
        if (c < 0 || c > 6) {
            return -1;
        }
        switch (b) {
            case 0: return (this.a5(a, c));
            case 1: return (this.a8(a, c, 7));
            case 2: return (this.a8(a, c, 4));
        }
        return -1;
    };
    Calendar.prototype.a5 = function (a, b) {
        var c = this.a4(a) - 1;
        var d = a.getDay();
        var e = d - (c % 7);
        var f = (e - b + 14) % 7;
        return (intDivide((c + f), 7) + 1);
    };
    Calendar.prototype.a8 = function (a, b, c) {
        var d;
        var e;
        var f;
        var g = this.a4(a) - 1;
        var h = a.getDay();
        d = h - (g % 7);
        e = (b - d + 14) % 7;
        if (e != 0 && e >= c) {
            e -= 7;
        }
        f = g - e;
        if (f >= 0) {
            return (intDivide(f, 7) + 1);
        }
        if (a <= dateAddDays(this.ar, g)) {
            return this.a9(b, c);
        }
        return (this.a8(dateAddDays(a, -(g + 1)), b, c));
    };
    Calendar.prototype.a9 = function (a, b) {
        var c = this.a4(this.ar) - 1;
        var d = this.o(this.ar) - c % 7;
        var e = (a + 7 - d) % 7;
        if (e == 0 || e >= b) {
            return 1;
        }
        var f = 365 - 1;
        var g = d - 1 - (f % 7);
        var h = (a - g + 14) % 7;
        var i = f - h;
        if (h >= b) {
            i += 7;
        }
        return (intDivide(i, 7) + 1);
    };
    Calendar.prototype.a4 = function (a) {
        return this.a3(a, 1);
    };
    Calendar.prototype.o = function (a) {
        return ((intDivide(a.getTime(), 0xC92A69C000) + 1) % 7);
    };
    Calendar.prototype.a3 = function (a, b) {
        var c = this.ba(a.getFullYear(), dateGetMonth(a), a.getDate());
        var d = (intDivide(c, 0xC92A69C000));
        var e = intDivide(d, 146097);
        d -= e * 146097;
        var f = intDivide(d, 36524);
        if (f == 4) {
            f = 3;
        }
        d -= f * 36524;
        var g = intDivide(d, 1461);
        d -= g * 1461;
        var h = intDivide(d, 365);
        if (h == 4) {
            h = 3;
        }
        if (b == 0) {
            return e * 400 + f * 100 + g * 4 + h + 1;
        }
        d -= h * 365;
        if (b == 1) {
            return d + 1;
        }
        var i = h == 3 && (g != 24 || f == 3);
        var j = i ? Calendar.b : Calendar.a;
        var k = d >> 5 + 1;
        while (d >= j[k]) {
            k++;
        }
        if (b == 2) {
            return k;
        }
        return d - j[k - 1] + 1;
    };
    Calendar.prototype.ba = function (a, b, c) {
        if (a >= 1 && a <= 9999 && b >= 1 && b <= 12) {
            var d = Calendar.y(a) ? Calendar.b : Calendar.a;
            if (c >= 1 && c <= d[b] - d[b - 1]) {
                var e = a - 1;
                var f = e * 365 + intDivide(e, 4) - intDivide(e, 100) + intDivide(e, 400) + d[b - 1] + c - 1;
                return f * 0xC92A69C000;
            }
        }
        return -1;
    };
    Calendar.y = function (a) {
        return a % 4 == 0 && (a % 100 != 0 || a % 400 == 0);
    };
    Calendar.prototype.cx = function (a, b, c) {
        var d = b.getChildAt(0);
        var e = c._inner[0];
        var f = this.i(a, d, e, Calendar.bh);
        f.bh = 28;
        f.bg = 28;
        e.parent().parent().setAttribute("aria-label", "Previous Month");
        f.ih = "btnPrev";
        this.af.add(f);
        e.setAttribute("data-section", "header");
        e.setAttribute("data-index", "0");
        e.setAttribute("data-disabled", "false");
        var g = b.getChildAt(1);
        var h = c._inner[1];
        var i = this.j(a, g, h);
        i.bh = 40;
        h.parent().parent().setAttribute("aria-label", "Select Month");
        i.ih = "btnMonth";
        this.af.add(i);
        h.setAttribute("data-section", "header");
        h.setAttribute("data-index", "1");
        h.setAttribute("data-disabled", "false");
        this.cu(h);
        var j = b.getChildAt(2);
        var k = c._inner[2];
        var l = this.j(a, j, k);
        l.bh = 40;
        k.parent().parent().setAttribute("aria-label", "Select Year");
        l.ih = "btnYear";
        this.af.add(l);
        k.setAttribute("data-section", "header");
        k.setAttribute("data-index", "2");
        k.setAttribute("data-disabled", "false");
        this.c3(k);
        var m = b.getChildAt(3);
        var n = c._inner[3];
        var o = this.i(a, m, n, Calendar.bi);
        o.bh = 28;
        o.bg = 28;
        n.parent().parent().setAttribute("aria-label", "Next Month");
        o.ih = "btnNext";
        this.af.add(o);
        n.setAttribute("data-section", "header");
        n.setAttribute("data-index", "3");
        n.setAttribute("data-disabled", "false");
        this.b8(c);
    };
    Calendar.prototype.b8 = function (a) {
        var b = this.an.getFullYear();
        var c = dateGetMonth(this.an);
        if (b == this.ar.getFullYear() && b == this.aq.getFullYear()) {
            this.af._inner[2].disabled = true;
            if (c == dateGetMonth(this.ar) && c == dateGetMonth(this.aq)) {
                this.af._inner[0].disabled = true;
                this.af._inner[1].disabled = true;
                this.af._inner[3].disabled = true;
            }
            else if (c == dateGetMonth(this.ar)) {
                this.af._inner[0].disabled = true;
                this.af._inner[1].disabled = false;
                this.af._inner[3].disabled = false;
            }
            else if (c == dateGetMonth(this.aq)) {
                this.af._inner[0].disabled = false;
                this.af._inner[1].disabled = false;
                this.af._inner[3].disabled = true;
            }
            else {
                this.af._inner[0].disabled = false;
                this.af._inner[1].disabled = false;
                this.af._inner[3].disabled = false;
            }
        }
        else {
            this.af._inner[2].disabled = false;
            if (b == this.ar.getFullYear()) {
                if (c == dateGetMonth(this.ar)) {
                    this.af._inner[0].disabled = true;
                    this.af._inner[1].disabled = false;
                    this.af._inner[3].disabled = false;
                }
                else {
                    this.af._inner[0].disabled = false;
                    this.af._inner[1].disabled = false;
                    this.af._inner[3].disabled = false;
                }
            }
            else if (b == this.aq.getFullYear()) {
                if (c == dateGetMonth(this.aq)) {
                    this.af._inner[0].disabled = false;
                    this.af._inner[1].disabled = false;
                    this.af._inner[3].disabled = true;
                }
                else {
                    this.af._inner[0].disabled = false;
                    this.af._inner[1].disabled = false;
                    this.af._inner[3].disabled = false;
                }
            }
            else if (b > this.aq.getFullYear() || b < this.ar.getFullYear()) {
                this.af._inner[0].disabled = true;
                this.af._inner[1].disabled = true;
                this.af._inner[3].disabled = true;
            }
        }
        for (var d = 0; d < this.af.count; d++) {
            if (this.af._inner[d].disabled == true) {
                a._inner[d].setAttribute("data-disabled", "true");
            }
            else {
                a._inner[d].setAttribute("data-disabled", "false");
            }
        }
    };
    Calendar.prototype.cu = function (a) {
        var b = a.getChildAt(0);
        var c = dateGetMonth(this.an);
        var d = "";
        switch (c) {
            case 1:
                d = !stringIsNullOrWhiteSpace(this.v.b1("January_Short")) ? this.v.b1("January_Short") : "Jan";
                break;
            case 2:
                d = !stringIsNullOrWhiteSpace(this.v.b1("February_Short")) ? this.v.b1("February_Short") : "Feb";
                break;
            case 3:
                d = !stringIsNullOrWhiteSpace(this.v.b1("March_Short")) ? this.v.b1("March_Short") : "Mar";
                break;
            case 4:
                d = !stringIsNullOrWhiteSpace(this.v.b1("April_Short")) ? this.v.b1("April_Short") : "Apr";
                break;
            case 5:
                d = !stringIsNullOrWhiteSpace(this.v.b1("May_Short")) ? this.v.b1("May_Short") : "May";
                break;
            case 6:
                d = !stringIsNullOrWhiteSpace(this.v.b1("June_Short")) ? this.v.b1("June_Short") : "Jun";
                break;
            case 7:
                d = !stringIsNullOrWhiteSpace(this.v.b1("July_Short")) ? this.v.b1("July_Short") : "Jul";
                break;
            case 8:
                d = !stringIsNullOrWhiteSpace(this.v.b1("August_Short")) ? this.v.b1("August_Short") : "Aug";
                break;
            case 9:
                d = !stringIsNullOrWhiteSpace(this.v.b1("September_Short")) ? this.v.b1("September_Short") : "Sep";
                break;
            case 10:
                d = !stringIsNullOrWhiteSpace(this.v.b1("October_Short")) ? this.v.b1("October_Short") : "Oct";
                break;
            case 11:
                d = !stringIsNullOrWhiteSpace(this.v.b1("November_Short")) ? this.v.b1("November_Short") : "Nov";
                break;
            case 12:
                d = !stringIsNullOrWhiteSpace(this.v.b1("December_Short")) ? this.v.b1("December_Short") : "Dec";
                break;
        }
        b.setText(d);
    };
    Calendar.prototype.c3 = function (a) {
        var b = a.getChildAt(0);
        var c = this.an.getFullYear().toString();
        b.setText(c);
    };
    Calendar.prototype.cz = function (a) {
        var b = new List$1(DayOfWeek_$type, 0);
        switch (this.n) {
            case 0:
                b.add(0);
                b.add(1);
                b.add(2);
                b.add(3);
                b.add(4);
                b.add(5);
                b.add(6);
                break;
            case 1:
                b.add(1);
                b.add(2);
                b.add(3);
                b.add(4);
                b.add(5);
                b.add(6);
                b.add(0);
                break;
            case 2:
                b.add(2);
                b.add(3);
                b.add(4);
                b.add(5);
                b.add(6);
                b.add(0);
                b.add(1);
                break;
            case 3:
                b.add(3);
                b.add(4);
                b.add(5);
                b.add(6);
                b.add(0);
                b.add(1);
                b.add(2);
                break;
            case 4:
                b.add(4);
                b.add(5);
                b.add(6);
                b.add(0);
                b.add(1);
                b.add(2);
                b.add(3);
                break;
            case 5:
                b.add(5);
                b.add(6);
                b.add(0);
                b.add(1);
                b.add(2);
                b.add(3);
                b.add(4);
                break;
            case 6:
                b.add(6);
                b.add(0);
                b.add(1);
                b.add(2);
                b.add(3);
                b.add(4);
                b.add(5);
                break;
        }
        this.ad.clear();
        for (var c = 0; c < b.count; c++) {
            var d = a.getChildAt(c);
            var e = d.getChildAt(0);
            if (b._inner[c] == 0) {
                var f = !stringIsNullOrWhiteSpace(this.v.b1("Sunday_Full")) ? this.v.b1("Sunday_Full") : "Sunday";
                d.setAttribute("title", f);
                d.setAttribute("aria-label", f);
                e.setText(!stringIsNullOrWhiteSpace(this.v.b1("Sunday_Single")) ? this.v.b1("Sunday_Single") : "S");
            }
            else if (b._inner[c] == 1) {
                var g = !stringIsNullOrWhiteSpace(this.v.b1("Monday_Full")) ? this.v.b1("Monday_Full") : "Monday";
                d.setAttribute("title", g);
                d.setAttribute("aria-label", g);
                e.setText(!stringIsNullOrWhiteSpace(this.v.b1("Monday_Single")) ? this.v.b1("Monday_Single") : "M");
            }
            else if (b._inner[c] == 2) {
                var h = !stringIsNullOrWhiteSpace(this.v.b1("Tuesday_Full")) ? this.v.b1("Tuesday_Full") : "Tuesday";
                d.setAttribute("title", h);
                d.setAttribute("aria-label", h);
                e.setText(!stringIsNullOrWhiteSpace(this.v.b1("Tuesday_Single")) ? this.v.b1("Tuesday_Single") : "T");
            }
            else if (b._inner[c] == 3) {
                var i = !stringIsNullOrWhiteSpace(this.v.b1("Wednesday_Full")) ? this.v.b1("Wednesday_Full") : "Wednesday";
                d.setAttribute("title", i);
                d.setAttribute("aria-label", i);
                e.setText(!stringIsNullOrWhiteSpace(this.v.b1("Wednesday_Single")) ? this.v.b1("Wednesday_Single") : "W");
            }
            else if (b._inner[c] == 4) {
                var j = !stringIsNullOrWhiteSpace(this.v.b1("Thursday_Full")) ? this.v.b1("Thursday_Full") : "Thursday";
                d.setAttribute("title", j);
                d.setAttribute("aria-label", j);
                e.setText(!stringIsNullOrWhiteSpace(this.v.b1("Thursday_Single")) ? this.v.b1("Thursday_Single") : "T");
            }
            else if (b._inner[c] == 5) {
                var k = !stringIsNullOrWhiteSpace(this.v.b1("Friday_Full")) ? this.v.b1("Friday_Full") : "Friday";
                d.setAttribute("title", k);
                d.setAttribute("aria-label", k);
                e.setText(!stringIsNullOrWhiteSpace(this.v.b1("Friday_Single")) ? this.v.b1("Friday_Single") : "F");
            }
            else if (b._inner[c] == 6) {
                var l = !stringIsNullOrWhiteSpace(this.v.b1("Saturday_Full")) ? this.v.b1("Saturday_Full") : "Saturday";
                d.setAttribute("title", l);
                d.setAttribute("aria-label", l);
                e.setText(!stringIsNullOrWhiteSpace(this.v.b1("Saturday_Single")) ? this.v.b1("Saturday_Single") : "S");
            }
            this.ad.add(e);
        }
    };
    Calendar.prototype.cw = function (a, b, c) {
        if (b === void 0) {
            b = false;
        }
        if (c === void 0) {
            c = false;
        }
        var d = null;
        var e = null;
        var f = null;
        for (var g = 0; g < 42; g++) {
            var h = a._inner[g];
            var i = h.getChildAt(0);
            var j = this.ae._inner[g];
            var k = this.ac._inner[g];
            h.parent().parent().setAttribute("aria-label", j.c.toString() + "/" + j.b.toString() + "/" + j.d.toString());
            if (j != null) {
                h.setAttribute("data-section", "days");
                h.setAttribute("data-index", g.toString());
                h.setAttribute("data-day", j.b.toString());
                h.setAttribute("data-month", j.c.toString());
                h.setAttribute("data-year", j.d.toString());
                h.setAttribute("data-selected", "false");
                h.setAttribute("data-disabled", "false");
                h.setAttribute("data-today", "false");
                h.parent().parent().setAttribute("aria-selected", "false");
                i.setText(j.b.toString());
                if (+(this.at) != +(dateMinValue()) && j.b == this.at.getDate() && j.c == dateGetMonth(this.at) && j.d == this.at.getFullYear()) {
                    k.s5 = this.dq;
                    k.s1 = this.dq;
                    k.sv = this.dp;
                    k.s0 = this.dr;
                    k.sw = this.di;
                    d = h;
                    h.parent().parent().setAttribute("aria-selected", "true");
                    h.setAttribute("data-selected", "true");
                }
                else if (j.b == this.as.getDate() && j.c == dateGetMonth(this.as) && j.d == this.as.getFullYear()) {
                    k.s5 = this.dk;
                    ;
                    k.s1 = this.dm;
                    k.sv = this.di;
                    k.s0 = this.dl;
                    k.sw = this.dj;
                    k.be = 1;
                    e = h;
                    h.setAttribute("data-today", "true");
                }
                else if (j.a != 0 && j.a != 6 && j.c == dateGetMonth(this.an)) {
                    k.s5 = this.ds;
                    k.s1 = this.dm;
                    k.sv = this.di;
                    k.s0 = this.dl;
                    k.sw = this.di;
                }
                else {
                    k.s5 = this.ds;
                    k.s1 = this.dm;
                    k.sv = this.di;
                    k.s0 = this.dl;
                    k.sw = this.di;
                }
                if (j.b == 1 && j.c == dateGetMonth(this.an)) {
                    f = h;
                }
                if (j.d >= this.ar.getFullYear() && j.d <= this.aq.getFullYear()) {
                    if (j.d == this.ar.getFullYear() && j.d == this.aq.getFullYear()) {
                        if (j.c == dateGetMonth(this.ar) && j.c == dateGetMonth(this.aq)) {
                            if (j.b >= this.ar.getDate() && j.b <= this.aq.getDate()) {
                                k.disabled = false;
                            }
                            else {
                                k.disabled = true;
                            }
                        }
                        else if (j.c >= dateGetMonth(this.ar) && j.c <= dateGetMonth(this.aq)) {
                            if (j.c == dateGetMonth(this.ar)) {
                                if (j.b >= this.ar.getDate()) {
                                    k.disabled = false;
                                }
                                else {
                                    k.disabled = true;
                                }
                            }
                            else if (j.c == dateGetMonth(this.aq)) {
                                if (j.b <= this.aq.getDate()) {
                                    k.disabled = false;
                                }
                                else {
                                    k.disabled = true;
                                }
                            }
                            else {
                                k.disabled = false;
                            }
                        }
                        else {
                            k.disabled = true;
                        }
                    }
                    else {
                        if (j.d == this.ar.getFullYear()) {
                            if (j.c >= dateGetMonth(this.ar)) {
                                if (j.c == dateGetMonth(this.ar)) {
                                    if (j.b >= this.ar.getDate()) {
                                        k.disabled = false;
                                    }
                                    else {
                                        k.disabled = true;
                                    }
                                }
                                else {
                                    k.disabled = false;
                                }
                            }
                            else {
                                k.disabled = true;
                            }
                        }
                        else if (j.d == this.aq.getFullYear()) {
                            if (j.c <= dateGetMonth(this.aq)) {
                                if (j.c == dateGetMonth(this.aq)) {
                                    if (j.b <= this.aq.getDate()) {
                                        k.disabled = false;
                                    }
                                    else {
                                        k.disabled = true;
                                    }
                                }
                                else {
                                    k.disabled = false;
                                }
                            }
                            else {
                                k.disabled = true;
                            }
                        }
                        else {
                            k.disabled = false;
                        }
                    }
                }
                else {
                    k.disabled = true;
                }
            }
            if (k.disabled) {
                h.setAttribute("data-disabled", "true");
            }
        }
        if (b == true) {
            if (d != null && +(this.at) != +(dateMinValue()) && this.at.getFullYear() == this.an.getFullYear() && dateGetMonth(this.at) == dateGetMonth(this.an)) {
                this.k.d(d);
            }
            else if (e != null && this.as.getFullYear() == this.an.getFullYear() && dateGetMonth(this.as) == dateGetMonth(this.an)) {
                this.k.d(e);
            }
            else if (f != null) {
                if (c == true) {
                    for (var l = 41; l >= 0; l--) {
                        var m = this.ae._inner[l];
                        if (m.c == dateGetMonth(this.an)) {
                            var n = this.ac._inner[l];
                            if (n.disabled == false) {
                                f = a._inner[l];
                                break;
                            }
                        }
                    }
                }
                else {
                    for (var o = 0; o < 42; o++) {
                        var p = this.ae._inner[o];
                        if (p.c == dateGetMonth(this.an)) {
                            var q = this.ac._inner[o];
                            if (q.disabled == false) {
                                f = a._inner[o];
                                break;
                            }
                        }
                    }
                }
                this.k.d(f);
            }
        }
    };
    Calendar.prototype.c0 = function (a) {
        var b = this.ab();
        this.ah.clear();
        for (var c = 0; c < 6; c++) {
            var d = a.getChildAt(c);
            var e = d.getChildAt(0);
            e.setText(b._inner[c].toString());
            this.ah.add(e);
        }
    };
    Calendar.prototype.cy = function (a) {
        var b = null;
        var c = null;
        var d = 0;
        var e = 0;
        var f = 0;
        for (var g = 0; g < 12; g++) {
            var h = a._inner[g];
            h.setAttribute("data-section", "months");
            h.setAttribute("data-year", this.an.getFullYear().toString());
            h.setAttribute("data-disabled", "false");
            h.parent().parent().setAttribute("aria-selected", "false");
            var i = g + 1;
            if (+(this.at) != +(dateMinValue()) && dateGetMonth(this.at) == i) {
                c = h;
                d = g;
                h.parent().parent().setAttribute("aria-selected", "true");
            }
            if (dateGetMonth(this.as) == i) {
                b = h;
                e = g;
            }
            if (this.an.getFullYear() >= this.ar.getFullYear() && this.an.getFullYear() <= this.aq.getFullYear()) {
                if (this.an.getFullYear() == this.ar.getFullYear() && this.an.getFullYear() == this.aq.getFullYear()) {
                    if (i < dateGetMonth(this.ar) || i > dateGetMonth(this.aq)) {
                        this.ag._inner[g].disabled = true;
                    }
                    else {
                        this.ag._inner[g].disabled = false;
                    }
                }
                else if (this.an.getFullYear() == this.ar.getFullYear()) {
                    if (i < dateGetMonth(this.ar)) {
                        this.ag._inner[g].disabled = true;
                    }
                    else {
                        this.ag._inner[g].disabled = false;
                    }
                }
                else if (this.an.getFullYear() == this.aq.getFullYear()) {
                    if (i > dateGetMonth(this.aq)) {
                        this.ag._inner[g].disabled = true;
                    }
                    else {
                        this.ag._inner[g].disabled = false;
                    }
                }
                else {
                    this.ag._inner[g].disabled = false;
                }
            }
            else {
                this.ag._inner[g].disabled = true;
            }
            if (this.ag._inner[g].disabled) {
                h.setAttribute("data-disabled", "true");
            }
        }
        for (var j = 0; j < this.ag.count; j++) {
            if (this.ag._inner[j].disabled == false) {
                f = j;
                break;
            }
        }
        if (c != null && this.ag._inner[d].disabled == false) {
            this.k.d(c);
        }
        else if (b != null && this.ag._inner[e].disabled == false) {
            this.k.d(b);
        }
        else if (this.ag._inner[f].disabled == false) {
            this.k.d(a._inner[f]);
        }
        else {
            this.k.ag();
        }
    };
    Calendar.prototype.c2 = function (a) {
        this.c1(a, this.an.getFullYear(), true);
    };
    Calendar.prototype.c1 = function (a, b, c) {
        if (c === void 0) {
            c = false;
        }
        if (b < this.ar.getFullYear()) {
            b = this.ar.getFullYear();
        }
        if (b > this.aq.getFullYear()) {
            b = this.aq.getFullYear();
        }
        var d = b - 3;
        var e = false;
        for (var f = 0; f < 7; f++) {
            var g = a._inner[f];
            g.setAttribute("data-section", "years");
            g.setAttribute("data-disabled", "false");
            g.parent().parent().setAttribute("aria-selected", "false");
            if (d < this.ar.getFullYear() || d > this.aq.getFullYear()) {
                this.ai._inner[f].disabled = true;
                g.setAttribute("data-disabled", "true");
            }
            else {
                this.ai._inner[f].disabled = false;
                g.setAttribute("data-disabled", "false");
            }
            var h = g.getChildAt(0);
            h.setText(d.toString());
            g.parent().parent().setAttribute("aria-label", d.toString());
            if (d == b && c) {
                if (this.ai._inner[f].disabled == false) {
                    g.parent().parent().setAttribute("aria-selected", "true");
                    e = true;
                    this.k.d(g);
                }
            }
            d++;
        }
        if (e == false) {
            if (this.ai._inner[3].disabled == false) {
                var i = a._inner[3];
                this.k.d(i);
            }
        }
    };
    Calendar.prototype.j = function (a, b, c) {
        c.setAttribute("aria-hidden", "true");
        var d = a.getSubRenderer(b);
        var e = new Button();
        e.provideContainer(d);
        e.d = this.d;
        e.h = this.f;
        e.v = this.s;
        e.eu = -1;
        e.s = 1;
        if (this.s != null) {
            e.v = this.s;
        }
        var f = a.createElement("span");
        f.setAttribute("aria-hidden", "true");
        var g = new CornerRadius(0, 2);
        e.ke = g;
        e.kv = g;
        e.ec = 0;
        c.append(f);
        e.appendButtonContent(c);
        c.parent().setAttribute("aria-hidden", "true");
        c.parent().parent().setAttribute("tabindex", "-1");
        c.parent().parent().setAttribute("aria-readonly", "true");
        c.parent().parent().setAttribute("aria-selected", "false");
        c.parent().parent().setAttribute("aria-disabled", "false");
        c.parent().parent().setAttribute("data-is-focusable", "true");
        e.s5 = this.ds;
        e.s1 = this.dm;
        e.sv = this.di;
        e.s0 = this.dl;
        e.s2 = this.dn;
        return e;
    };
    Calendar.prototype.i = function (a, b, c, d) {
        c.setAttribute("aria-hidden", "true");
        var e = a.getSubRenderer(b);
        var f = new Button();
        f.provideContainer(e);
        f.d = this.d;
        f.h = this.f;
        f.v = this.s;
        f.eu = -1;
        f.s = 1;
        var g = new CornerRadius(0, 2);
        f.ke = g;
        f.kv = g;
        f.ec = 0;
        var h = a.createElement("div");
        h.setAttribute("aria-hidden", "true");
        var i = a.getSubRenderer(h);
        var j = new Icon();
        j.provideContainer(i);
        j.svgPath = d;
        c.append(h);
        f.appendButtonContent(c);
        c.parent().setAttribute("aria-hidden", "true");
        c.parent().parent().setAttribute("tabindex", "-1");
        c.parent().parent().setAttribute("aria-readonly", "true");
        c.parent().parent().setAttribute("aria-selected", "false");
        c.parent().parent().setAttribute("aria-disabled", "false");
        c.parent().parent().setAttribute("data-is-focusable", "true");
        f.s5 = this.ds;
        f.s1 = this.dm;
        f.sv = this.di;
        f.s0 = this.dl;
        f.s2 = this.dn;
        return f;
    };
    Calendar.prototype.b7 = function (a) {
        this.an = dateAddMonths(this.an, a);
        this.cc();
    };
    Calendar.prototype.b9 = function (a) {
        this.an = dateFromValues(this.an.getFullYear(), a, this.an.getDate(), 0, 0, 0, 0);
        this.cc();
    };
    Calendar.prototype.ca = function (a) {
        var b = dateGetMonth(this.an);
        var c = this.an.getDate();
        if (a == this.ar.getFullYear() && a == this.aq.getFullYear()) {
            if (b < dateGetMonth(this.ar)) {
                b = dateGetMonth(this.ar);
                if (c < this.ar.getDate()) {
                    c = this.ar.getDate();
                }
            }
            else if (b > dateGetMonth(this.aq)) {
                b = dateGetMonth(this.aq);
                if (c > this.aq.getDate()) {
                    c = this.aq.getDate();
                }
            }
            else if (b == dateGetMonth(this.ar) && b == dateGetMonth(this.aq)) {
                if (c < this.ar.getDate()) {
                    c = this.ar.getDate();
                }
                else if (c > this.aq.getDate()) {
                    c = this.aq.getDate();
                }
            }
            else if (b == dateGetMonth(this.ar)) {
                if (c < this.ar.getDate()) {
                    c = this.ar.getDate();
                }
            }
            else if (b == dateGetMonth(this.aq)) {
                if (c > this.aq.getDate()) {
                    c = this.aq.getDate();
                }
            }
        }
        else if (a == this.ar.getFullYear()) {
            if (b < dateGetMonth(this.ar)) {
                b = dateGetMonth(this.ar);
                if (c < this.ar.getDate()) {
                    c = this.ar.getDate();
                }
            }
            else if (b == dateGetMonth(this.ar)) {
                if (c < this.ar.getDate()) {
                    c = this.ar.getDate();
                }
            }
        }
        else if (a == this.aq.getFullYear()) {
            if (b > dateGetMonth(this.aq)) {
                b = dateGetMonth(this.aq);
                if (c > this.aq.getDate()) {
                    c = this.aq.getDate();
                }
            }
            else if (b == dateGetMonth(this.aq)) {
                if (c > this.aq.getDate()) {
                    c = this.aq.getDate();
                }
            }
        }
        this.an = dateFromValues(a, b, c, 0, 0, 0, 0);
        this.cc();
    };
    Calendar.prototype.cs = function (a, b) {
        var c = parseInt(a._inner[3].getChildAt(0).getText());
        if (b < 0) {
            c--;
        }
        else {
            c++;
        }
        this.c1(a, c);
    };
    Calendar.prototype.cr = function () {
        this.k.ag();
    };
    Calendar.prototype.bg = function () {
        return this.g();
    };
    Calendar.prototype.bp = function () {
        var a = this.g();
        return a.o();
    };
    Calendar.prototype.g = function () {
        var a = new CalendarVisualModelExport();
        a.i = this.f;
        a.h = this.d;
        a.e = AppearanceHelper.a(this.dp);
        a.g = AppearanceHelper.a(this.dr);
        a.c = AppearanceHelper.a(this.dl);
        a.f = AppearanceHelper.a(this.dq);
        a.d = AppearanceHelper.a(this.dm);
        a.b = AppearanceHelper.a(this.dk);
        a.a = AppearanceHelper.a(this.dj);
        a.j = new List$1(ButtonVisualModelExport.$, 0);
        a.k = new List$1(TextElementsVisualModelExport.$, 0);
        a.l = new List$1(TextElementsVisualModelExport.$, 0);
        var b = this.k.r();
        a.n = b;
        var c = this.k.a();
        var d = c[0];
        var e = c[1];
        if (b == "day") {
            for (var f = 0; f < this.af.count; f++) {
                if (this.af._inner[f].ih == null) {
                    this.af._inner[f].ih = "header" + f.toString();
                }
                var g = this.af._inner[f].ey();
                g.s = g.s - d;
                g.q = g.q - e;
                a.j.add(g);
            }
            for (var h = 0; h < this.ac.count; h++) {
                if (this.ac._inner[h].ih == null) {
                    this.ac._inner[h].ih = "days" + h.toString();
                }
                var i = this.ac._inner[h].ey();
                i.s = i.s - d;
                i.q = i.q - e;
                a.j.add(i);
            }
            if (this.z == true) {
                this.h.ih = "todayButton";
                var j = this.h.ey();
                j.s = j.s - d;
                j.q = j.q - e;
                a.j.add(j);
            }
            for (var k = 0; k < this.ad.count; k++) {
                var l = new TextElementsVisualModelExport();
                var m = this.k.b(this.ad._inner[k]);
                l.e = m[0] - d;
                l.d = m[1] - e;
                l.c = NativeUI.c(this.ad._inner[k].parent());
                l.f = NativeUI.h(this.ad._inner[k].parent());
                l.b = AppearanceHelper.a(NativeUI.af(this.ad._inner[k]));
                l.g = this.ad._inner[k].getText();
                a.k.add(l);
            }
            if (this.aa == true) {
                for (var n = 0; n < this.ah.count; n++) {
                    var o = new TextElementsVisualModelExport();
                    var p = this.k.b(this.ah._inner[n]);
                    o.e = p[0] - d;
                    o.d = p[1] - e;
                    o.c = NativeUI.c(this.ah._inner[n].parent());
                    o.f = NativeUI.h(this.ah._inner[n].parent());
                    o.b = AppearanceHelper.a(NativeUI.af(this.ah._inner[n]));
                    o.a = AppearanceHelper.a(NativeUI.ae(this.ah._inner[n]));
                    o.g = this.ah._inner[n].getText();
                    a.l.add(o);
                }
            }
        }
        else if (b == "month") {
            for (var q = 0; q < this.ag.count; q++) {
                if (this.ag._inner[q].ih == null) {
                    this.ag._inner[q].ih = "months" + q.toString();
                }
                var r = this.ag._inner[q].ey();
                r.s = r.s - d;
                r.q = r.q - e;
                a.j.add(r);
            }
        }
        else if (b == "year") {
            for (var s = 0; s < this.ai.count; s++) {
                if (this.ai._inner[s].ih == null) {
                    this.ai._inner[s].ih = "years" + s.toString();
                }
                var t = this.ai._inner[s].ey();
                t.s = t.s - d;
                t.q = t.q - e;
                a.j.add(t);
            }
        }
        if (this.t != null) {
            var u = this.t;
            if (this.k != null && u.n == null) {
                var v = this.k.i;
                var w = FontUtil.getFontInfoFromString(v, u.fontString);
                u.n = w.n;
                u.d = w.d;
                u.o = w.o;
                u.q = w.q;
                u.r = w.r;
                u.s = w.s;
            }
            if (u.n != null) {
                a.p = u.n;
            }
            if (!isNaN_(u.d)) {
                a.m = u.d;
            }
            if (u.s != null) {
                a.t = u.s;
            }
            if (u.q != null) {
                a.r = u.q;
            }
            if (u.o != null) {
                a.q = u.q;
            }
        }
        return a;
    };
    Calendar.$t = markType(Calendar, 'Calendar', Base.$, [INotifyPropertyChanged_$type]);
    Calendar.bh = "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z";
    Calendar.bi = "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z";
    Calendar.a = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365];
    Calendar.b = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335, 366];
    return Calendar;
}(Base));
export { Calendar };
//# sourceMappingURL=CalendarView_combined.js.map
